export default __webpack_public_path__ + "static/media/zoomies.7b6bb403.gif";